import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { firstValueFrom, map } from 'rxjs';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class GraphqlService {
  constructor(
    private apollo: Apollo,
    private messageService: MessageService,
    private router: Router,
  ) {}

  async runQuery(query: any, variables?: any): Promise<any> {
    if (typeof query === 'string') {
      query = gql(query);
    }

    return await firstValueFrom(
      this.apollo
        .query({
          query,
          variables,
          errorPolicy: 'all',
          context: {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          },
        })
        .pipe(
          map((res) => {
            if (res.errors) {
              const message: any =
                res.errors?.[0]?.extensions?.['message'] ||
                res.errors?.[0]?.message ||
                'Default fallback message';

              this.messageService.add({
                severity: 'error',
                summary: 'Operation unsuccessful',
                detail: message as string,
                life: 1500,
              });
              console.log(message);
              if (message === 'Signature has expired') {
                this.logout();
              }
              return res;
            }

            return res.data;
          }),
        ),
    );
  }

  async runMutation(mutation: any, variables?: any): Promise<any> {
    if (typeof mutation === 'string') {
      mutation = gql(mutation);
    }

    return await firstValueFrom(
      this.apollo
        .mutate({
          mutation,
          variables,
          errorPolicy: 'all',
          context: {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          },
        })
        .pipe(
          map((res) => {
            if (
              res.errors &&
              res.errors.length > 0 &&
              res.errors[0].extensions
            ) {
              const message: unknown = res.errors[0].extensions['message'];
              this.messageService.add({
                severity: 'error',
                summary: 'Operation unsuccessful',
                detail: message as string,
                life: 1500,
              });
              if (message === 'Signature has expired') {
                this.logout();
              }
              return res;
            }
            this.messageService.add({
              severity: 'success',
              summary: 'Operation successful',
              detail: 'Data is successfully updated',
              life: 1500,
            });

            return res.data;
          }),
        ),
    );
  }

  logout(): void {
    localStorage.removeItem('user');
    this.router.navigate(['auth/login']);
  }
}
